import React, { Component } from 'react'
import styles from './styles'
import classNames from 'classnames'
import ProjectTable from 'components/projectTable'
import TaskTable from 'components/taskTable'
import UserTable from 'components/userTable'
import SpecialDateTable from 'components/specialDateTable'
import RecordExportForm from 'components/recordExportForm'
import OvertimeExportForm from 'components/overtimeExportForm'

class AdminPage extends Component {

  constructor (props, context) {
    super(props, context)
  }

  state = {
    tab: AdminPage.Tab.project,
  };

  static Tab = {
    project: 'projectTab',
    task: 'taskTab',
    user: 'userTab',
    specialDate: 'specialDateTab',
    recordExport: 'recordExportTab',
    overtimeExport: 'overtimeExportTab',
  };

  render () {
    const tab = this.state.tab
    let content = null
    const TabType = AdminPage.Tab
    switch (tab) {
      case TabType.project:
        content = <ProjectTable />
        break
      case TabType.task:
        content = <TaskTable />
        break
      case TabType.user:
        content = <UserTable />
        break
      case TabType.specialDate:
        content = <SpecialDateTable />
        break
      case TabType.recordExport:
        content = <RecordExportForm />
        break
      case TabType.overtimeExport:
        content = <OvertimeExportForm />
        break
      default:
    }

    const getOnTabClick = (tabType) => () => this.setState({ tab: tabType })
    const getTab = (text, tabType) => (
      <div
        className={classNames(
          styles.sideBarItem,
          { [styles.selected]: tab === tabType }
        )}
        onClick={getOnTabClick(tabType)}
      >
        {text}
      </div>
    )

    return (
      <div className={styles.adminPage}>
        <div className={styles.sideBar}>
          {getTab('專案管理', TabType.project)}
          {getTab('內容代碼管理', TabType.task)}
          {getTab('使用者管理', TabType.user)}
          {getTab('加/補班日管理', TabType.specialDate)}
          {getTab('匯出工時紀錄', TabType.recordExport)}
          {getTab('匯出加班統計', TabType.overtimeExport)}
        </div>
        <div className={styles.tabArea}>
          {content}
        </div>
      </div>
    )
  }
}

export default AdminPage



// WEBPACK FOOTER //
// ./src/app/adminPage.jsx